import { deviceTypesApi } from "@/services/api/deviceTypes.api";
import appSnackbarService from "@/services/appSnackbar.service";
import i18n from "@/services/i18n";
import { fileDownloader } from "@/services/file-downloader.service";

interface DeviceTypeRequest {
  sortBy: string;
  descending: string;
  page: number;
  rowsPerPage: number;
  searchString: string[];
}

interface DeviceTypePost {
  data: object;
  index: number;
}

interface DeviceTypeDelete {
  id: number;
  index: number;
}

export const deviceTypesState: any = {
  namespaced: false,
  state: {
    deviceTypes: [],
    totalItem: 0,
    total: 0,
    loading: true,
    fetching: false
  },
  mutations: {
    // load deviceTypes
    DEVICE_TYPE_FETCH_SUCCESS(state: any, payload: any) {
      state.deviceTypes = payload.data;
      state.total = payload.data.length;
      state.totalItem = payload.totalCount;
      state.loading = false;
      state.fetching = false;
    },
    DEVICE_TYPE_FETCH_START(state: any) {
      state.fetching = true;
    },
    DEVICE_TYPE_FETCH_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
    },

    // save
    DEVICE_TYPE_SAVE_SUCCESS(state: any, payload: any) {
      if (payload.index > -1) {
        // update
        state.deviceTypes.splice(payload.index, 1, payload.data);
      } else {
        // add
        state.deviceTypes.push(payload.data);
      }
    },
    DEVICE_TYPE_SAVE_START(state: any) {
      state.fetching = true;
    },
    DEVICE_TYPE_SAVE_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
    },

    // delete
    DEVICE_TYPE_DELETE_SUCCESS(state: any, payload: any) {
      if (payload.index > -1) {
        state.deviceTypes.splice(payload.index, 1);
        state.loading = false;
      }
    },
    DEVICE_TYPE_DELETE_START(state: any) {
      state.fetching = true;
      state.loading = true;
    },
    DEVICE_TYPE_DELETE_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
      state.loading = false;
    },
  },
  actions: {
    getDeviceTypes({ commit }: any, request: DeviceTypeRequest) {
      commit("DEVICE_TYPE_FETCH_START");

      const promise = new Promise((resolve, reject) => {
        deviceTypesApi
          .getAll(request)
          .then(response => {
            commit("DEVICE_TYPE_FETCH_SUCCESS", response.data);
            resolve(response);
          })
          .catch(error => {
            commit("DEVICE_TYPE_FETCH_ERROR", error);
            reject(error);
          });
      });
      return promise;
    },
    saveDeviceType({ commit }: any, payload: DeviceTypePost) {
      commit("DEVICE_TYPE_SAVE_START");
      const editedIndex = payload.index;

      const promise = new Promise((resolve, reject) => {
        deviceTypesApi
          .save(payload.data)
          .then(response => {
            commit("DEVICE_TYPE_SAVE_SUCCESS", {
              data: response.data,
              index: editedIndex
            });
            appSnackbarService.success(i18n.t("SUCCESS_MESSAGES.DEVICE_TYPE_SAVED"));
            resolve(response);
          })
          .catch(error => {
            commit("DEVICE_TYPE_SAVE_ERROR", error);
            reject(error);
          });
        });
      return promise;
    },
    deleteDeviceType({ commit }: any, payload: DeviceTypeDelete) {
      commit("DEVICE_TYPE_DELETE_START");

      const deletedIndex = payload.index;
      deviceTypesApi
        .delete(payload.id)
        .then(response => {
          commit("DEVICE_TYPE_DELETE_SUCCESS", {
            data: response.data,
            index: deletedIndex
          });
          appSnackbarService.warning(i18n.t("SUCCESS_MESSAGES.DEVICE_TYPE_DELETED"));
        })
        .catch(error => {
          commit("DEVICE_TYPE_DELETE_ERROR", error);
        });
    },
  }
};
